// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"f20feb87","397":"13d512f1"}[chunkId] + ".chunk.js";
};